// removed by extract-text-webpack-plugin
module.exports = {"Content":"_3jkytdY-JFNSlDLTurPNTg","Column":"_1JCqJADqGz9aZO3egFTdE3","Title":"_2jco4MNV-k7BohKknqPJwd","Text":"_2NAvAId_MxLxcGOFnggS7D","InputWrap":"_20vcI7xPLtMHrgpZdovMdT","DoubleCell":"_2htQdOOL2Y5ghpgbfEi5xj","Input":"_35R2TOnejkZwwbd9i68FCr","Calendar":"_1PRnw-3wTqgp_S2ZtpWm-f","Label":"_1HZui5KJz4HMJOYp5ypYll","container-fluid":"mO48Q1oa3k2yzgCfgYJgb"};


//////////////////
// WEBPACK FOOTER
// ./src/PagesOfUser/Metal/ContractCreate/styles.module.css
// module id = 628
// module chunks = 0